import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";

function App() {
  const [cart, setCart] = useState([]);

  // Load cart from localStorage on mount
  useEffect(() => {
    const savedCart = localStorage.getItem('soletosoul_cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('soletosoul_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => {
    // Handle bundles differently
    if (item.isBundle) {
      setCart([...cart, item]);
      return;
    }

    // Regular products
    const existingItem = cart.find(cartItem => cartItem.id === item.id && !cartItem.bundleId);
    
    if (existingItem) {
      setCart(cart.map(cartItem => 
        cartItem.id === item.id && !cartItem.bundleId
          ? { ...cartItem, quantity: cartItem.quantity + 1 }
          : cartItem
      ));
      toast.success(`Added another ${item.name} to cart!`);
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
      toast.success(`${item.name} added to cart!`);
    }
  };

  const updateQuantity = (itemId, bundleId, newQuantity) => {
    if (newQuantity < 1) return;
    
    setCart(cart.map(item =>
      (bundleId ? item.bundleId === bundleId : item.id === itemId && !item.bundleId)
        ? { ...item, quantity: newQuantity }
        : item
    ));
  };

  const removeFromCart = (itemId, bundleId) => {
    const item = cart.find(item => 
      bundleId ? item.bundleId === bundleId : (item.id === itemId && !item.bundleId)
    );
    setCart(cart.filter(item => 
      bundleId ? item.bundleId !== bundleId : (item.id !== itemId || item.bundleId)
    ));
    toast.info(`${item.name} removed from cart`);
  };

  const clearCart = () => {
    setCart([]);
    toast.info('Cart cleared');
  };

  const cartItemCount = cart.reduce((total, item) => {
    if (item.isBundle) {
      return total + item.products.length * item.quantity;
    }
    return total + item.quantity;
  }, 0);

  return (
    <div className="App">
      <BrowserRouter>
        <Header cartItemCount={cartItemCount} />
        <main className="main-content">
          <Routes>
            <Route 
              path="/" 
              element={<Home cart={cart} addToCart={addToCart} />} 
            />
            <Route 
              path="/cart" 
              element={
                <Cart 
                  cart={cart} 
                  updateQuantity={updateQuantity}
                  removeFromCart={removeFromCart}
                  clearCart={clearCart}
                />
              } 
            />
            <Route 
              path="/admin" 
              element={<Admin />} 
            />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
